import gql from 'graphql-tag'
export default gql`
    query ViewCompanyNameAutocompletes ($value: Value!,$limit: Int, $offset: Int, $ignoreCase: Boolean) {
      ViewCompanyNameAutocompletes (value: $value, limit: $limit, offset: $offset, ignoreCase: $ignoreCase) {
        id
        name
        pos
        companyID
      }
    }
  `
